import { Actions } from '../constants';

export function trigger(payload) {
  return {
    type: Actions.TRIGGER,
    meta: {
      hotjar: {
        type: 'trigger',
        payload,
      },
    },
  };
}
